
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punecabservice() {



  const cardData =
  {
    keyword: ' Pune Cab Service',
    heading: 'Vaishnavi Travels: Pune Cab Service',
    headingDescription: 'Vaishnavi Travels provides professional and affordable Pune Cab Service, catering to all your local and outstation travel needs. Our fleet includes well-maintained cars with comfortable seating, strong air-conditioning, and ample luggage space to ensure a smooth and enjoyable ride. With professional chauffeurs, punctual pickups, and flexible booking options, we make every journey convenient and stress-free. Whether it’s airport transfers, corporate travel, weddings, family functions, or weekend getaways, Vaishnavi Travels guarantees safe, reliable, and comfortable cab services in Pune at the best prices.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace and a symbol of Maratha pride. Once the political seat of the Maratha Empire, its mighty gates, fountains, and sprawling courtyards echo with history. Though destroyed partially by fire in 1828, the ruins still captivate visitors. The evening light-and-sound show revives tales of Bajirao and Mastani. Tourists enjoy exploring its historic pathways and gardens. Shaniwar Wada is Pune’s crown jewel of heritage and culture."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a national monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum showcasing Gandhi’s belongings, photos, and letters. Its Italian arches and sprawling gardens add beauty and peace. Tourists enjoy a calm retreat here while reflecting on history. Aga Khan Palace is Pune’s inspirational heritage landmark of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched on a hill 25 km from Pune, is famed for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. Trekkers climb its rugged trails for panoramic views of the Sahyadris. The fort still has bastions, gates, and memorials that narrate Maratha valor. In monsoon, mist and waterfalls make the fort even more scenic. Local stalls serve rustic pithla-bhakri to hungry visitors. Sinhagad is Pune’s blend of history, trekking, and natural charm."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established over 125 years ago, the temple houses a magnificent idol adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. Known for its charitable initiatives, it attracts lakhs of devotees each year. The spiritual aura here uplifts every visitor. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is an ancient rock-cut shrine dedicated to Lord Shiva. Its massive stone pillars, sanctum, and Nandi mandapa reflect fine Indian craftsmanship. Despite being in the heart of the city, it offers peace and meditation. Evening chants add mystical charm to the temple. History and architecture enthusiasts admire its simplicity. Pataleshwar is Pune’s hidden gem of spiritual heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure with over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include ornaments, musical instruments, sculptures, and everyday antiques. A highlight is the recreated Mastani Mahal, showcasing Maratha romance and artistry. Students and history lovers find the museum highly educational. It preserves centuries of Indian traditions under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of art and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage sites, offers a panoramic view of the city. The hilltop temple complex is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Smaller shrines and a museum nearby enrich the visit. Pilgrims climb 103 steps to reach the top, blending devotion with scenic beauty. Sunrise and sunset views are breathtaking from here. Parvati Hill is Pune’s sacred and serene retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub for wellness and spirituality. Spread across lush gardens, it attracts seekers from all over the world. Meditation sessions, yoga practices, and self-development workshops are conducted here. Its Japanese Zen gardens and peaceful halls enhance the experience. Beyond spirituality, it is also a rejuvenation retreat. Osho Ashram is Pune’s international destination for peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Its streams, bridges, and manicured lawns attract families and nature lovers. Seasonal flowers and colorful landscaping add to its charm. It symbolizes Indo-Japanese cultural friendship. Visitors enjoy evening walks, photography, and picnics here. Pu La Deshpande Garden is Pune’s green paradise of tranquility."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite weekend getaway near Pune. It provides water to the city while offering a scenic retreat. In monsoon, the overflowing dam creates spectacular views. Families gather here for roasted corn, tea, and leisure by the banks. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla Dam is Pune’s refreshing natural escape for relaxation."
  }
],


      "services": [
    {
      "name": "Pune Local Cab Service",
      "description": "Reliable and convenient local cab services within Pune city, ideal for daily commuting, shopping trips, and city errands. Our drivers are familiar with Pune’s routes and traffic patterns to ensure timely and safe rides anywhere in the city."
    },
    {
      "name": "City Cab Booking Pune",
      "description": "Easily book city cabs in Pune via phone or online platforms with instant confirmations. Whether it’s a quick ride across town or multiple stops, our city cabs provide comfortable and affordable transport tailored to your schedule."
    },
    {
      "name": "Affordable Cabs in Pune",
      "description": "Get budget-friendly cab options for short and medium-distance rides in Pune. Our economical fleet caters to cost-conscious travelers without compromising safety or punctuality, making everyday travel hassle-free."
    },
    {
      "name": "AC City Taxi Pune",
      "description": "Experience the comfort of air-conditioned city taxis in Pune, perfect for summer months or longer rides. These AC cabs offer well-maintained vehicles with cool interiors, ensuring a refreshing travel experience within the city."
    },
    {
      "name": "Non AC Pune Cab Service",
      "description": "Non-AC cab options are available for travelers who prefer economical and simple city rides. These vehicles are regularly sanitized, maintained, and driven by experienced professionals for a safe journey."
    },
    {
      "name": "Outstation Cab from Pune",
      "description": "Book outstation cabs starting from Pune for trips to nearby cities and tourist destinations. Our fleet includes sedans, SUVs, and tempo travellers to suit solo travelers, families, or groups, ensuring comfortable and punctual travel beyond city limits."
    },
    {
      "name": "Corporate Cab Service Pune",
      "description": "Tailored cab services for corporate clients in Pune including employee transportation, airport transfers, and business travel. Our corporate cabs offer professionalism, punctuality, and reliable scheduling to meet all your business needs."
    },
    {
      "name": "Airport Drop Cab Pune",
      "description": "Punctual and comfortable airport drop cabs in Pune for domestic and international flights. Drivers track your flight status to ensure timely pickups and drop-offs, reducing travel stress and guaranteeing a smooth start or end to your journey."
    },
    {
      "name": "Pick and Drop Cabs Pune",
      "description": "Convenient pick and drop cab services across Pune for schools, offices, and daily errands. Flexible scheduling and reliable drivers make these cabs perfect for regular commuting and special appointments."
    },
    {
      "name": "Family Travel Cab Service Pune",
      "description": "Safe and spacious cab services designed specifically for family travel within Pune. Vehicles are equipped with child safety seats upon request, and drivers are trained to provide courteous, family-friendly service for trips around the city."
    },
    {
      "name": "Online Cab Booking Pune",
      "description": "Book your Pune cabs online anytime with easy-to-use apps and websites. Instant booking confirmation, multiple payment options, and live ride tracking offer a seamless and transparent travel experience."
    },
    {
      "name": "24x7 Cab Service Pune",
      "description": "Round-the-clock cab service in Pune to cater to your travel needs anytime, day or night. Whether it’s an emergency trip, late-night airport run, or early morning commute, our 24/7 fleet is ready to serve you with promptness and safety."
    },
    {
      "name": "Pune Mini Cab Service",
      "description": "Compact and fuel-efficient mini cabs available for quick and economical city rides in Pune. Perfect for single travelers or small groups looking for swift and budget-friendly transport around town."
    }
  ],
  "tableData": [
    ["Pune Local Cab Service", "City Cab Booking Pune"],
    ["Affordable Cabs in Pune", "AC City Taxi Pune"],
    ["Non AC Pune Cab Service", "Outstation Cab from Pune"],
    ["Corporate Cab Service Pune", "Airport Drop Cab Pune"],
    ["Pick and Drop Cabs Pune", "Family Travel Cab Service Pune"],
    ["Online Cab Booking Pune", "24x7 Cab Service Pune"],
    ["Pune Mini Cab Service"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune Cab Service",
    "WhyChoosedescription": "Vaishnavi Travels provides dependable and comfortable cab services across Pune for local travel, airport transfers, corporate trips, and sightseeing."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Choose From",
    "WhyChoosedescription": "Select from economy cars like Swift Dzire, spacious SUVs like Innova, or luxury options like Urbania based on your travel needs."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Fleet",
    "WhyChoosedescription": "All cabs are regularly serviced and thoroughly cleaned to ensure a safe and hygienic ride."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our professional drivers are trained for safe driving and provide timely, polite service across Pune."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from hourly rentals, daily hires, or long-term packages tailored to your schedule and preferences."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Our fares include fuel, tolls, taxes, and driver allowance for a hassle-free experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Airport, and Leisure Travel",
    "WhyChoosedescription": "Whether for office commute, airport transfers, or city tours, our Pune cab service has you covered."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Experience",
    "WhyChoosedescription": "Our customer care team is available round-the-clock to assist with bookings, cancellations, and queries."
  }
]














  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer cab services within Pune?',
      answer: 'Yes, Vaishnavi Travels offers reliable and affordable cab services for local travel within Pune, including point-to-point transfers, hourly rentals, and full-day bookings.',
    },
    {
      question: 'What types of vehicles are available in the Pune cab service?',
      answer: 'We provide a variety of options including Swift Dzire, Ertiga, Innova, and even Tempo Travellers depending on your travel needs and group size.',
    },
    {
      question: 'Can I book a cab for hourly or full-day usage in Pune?',
      answer: 'Yes, you can book a cab for hourly use (minimum 4 hours) or opt for full-day packages for business meetings, shopping, sightseeing, or personal errands.',
    },
    {
      question: 'Are the drivers professional and well-trained?',
      answer: 'Absolutely! All our drivers are experienced, courteous, and familiar with Pune city routes, ensuring a safe and comfortable ride every time.',
    },
    {
      question: 'What are the starting fares for Pune cab services?',
      answer: 'Local cab fares start from ₹1,200 for a 4-hour/40 km package. Pricing may vary depending on the vehicle type and total duration or distance traveled.',
    },
    {
      question: 'Is advance booking required for local cab service in Pune?',
      answer: 'While we do accept last-minute bookings, it is recommended to book at least a few hours in advance to ensure vehicle availability and timely service.',
    },
    {
      question: 'Is doorstep pickup and drop-off available in Pune?',
      answer: 'Yes, we offer convenient doorstep pickup and drop services anywhere in Pune and nearby areas to make your travel seamless and stress-free.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Nikhil Joshi",
    position: "IT Professional",
    feedback:
      "I use Vaishnavi Travels regularly for local cab service in Pune. The cars are always clean, the drivers are polite, and the service is very reliable.",
    rating: 5,
  },
  {
    name: "Ms. Arpita Khedekar",
    position: "Entrepreneur",
    feedback:
      "Vaishnavi Travels provides excellent cab service in Pune. They’re always on time, and the rates are very reasonable. Highly recommended for local travel!",
    rating: 5,
    style: "style-2",
  }
];











































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune Cab Service",
  "description": "Reliable Pune cab service offering local city cabs, affordable AC and Non-AC taxis, airport transfers, corporate and family travel, available 24x7 with easy online booking.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "areaServed": "Pune",
    "url": "https://vaishnavitravel.com/pune-cab-service"
  },
  "serviceType": "Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "200",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-cab-service"
  }
};



  return (
    <div>


<Helmet>
  <title>Pune Cab Service | Affordable Local & Outstation Taxi</title>
  <meta
    name="description"
    content="Reliable Pune cab service offering local city cabs, affordable AC and Non-AC taxis, airport transfers, corporate and family travel, available 24x7 with easy online booking."
  />
  <meta
    name="keywords"
    content="Pune Local Cab Service, City Cab Booking Pune, Affordable Cabs in Pune, AC City Taxi Pune, Non AC Pune Cab Service, Outstation Cab from Pune, Corporate Cab Service Pune, Airport Drop Cab Pune, Pick and Drop Cabs Pune, Family Travel Cab Service Pune, Online Cab Booking Pune, 24x7 Cab Service Pune, Pune Mini Cab Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/58.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punecabservice;